module.exports = __webpack_public_path__ + "static/media/icon_paystack.769ee98d.png";